import { MediaId } from './MediaId';
import { isNonEmptyString } from '../utilities';

export function isMediaId(mediaId: unknown): mediaId is MediaId {
  return isNonEmptyString(mediaId);
}
